// German for the Scope document page. Registered on load.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Full': 'Vollständig',
  'Draft — requirements and deliverables only': 'Entwurf — nur Anforderungen und Lieferobjekte',
  'Full — the complete Statement of Work structure': 'Vollständig — die komplette Struktur des Statement of Work',
  'Mode': 'Modus',
  'Print': 'Drucken',
  'Print the traceability sheets — A4 landscape, one deliverable per sheet': 'Die Nachverfolgbarkeitsblätter drucken — A4 quer, ein Lieferobjekt pro Blatt',
  'Rendered from the live register — not an issued SOW. Priority and type are editable here and write straight to the register; rows inside a signed baseline are locked.': 'Aus dem aktuellen Register gerendert — kein ausgestelltes SOW. Priorität und Typ sind hier direkt editierbar und schreiben ins Register; Zeilen innerhalb einer unterzeichneten Baseline sind gesperrt.',
  'Select an engagement to render its scope document.': 'Wählen Sie einen Auftrag, um seinen Leistungsbeschrieb zu rendern.',
  'Loading the register…': 'Register wird geladen…',
  '{n} requirements': '{n} Anforderungen',
  '{n} deliverables': '{n} Lieferobjekte',
  'rendered {when}': 'gerendert {when}',
  'Saved {ref}: {field} → {value}': '{ref} gespeichert: {field} → {value}',
  'Locked — inside a signed baseline; change it through a change request.': 'Gesperrt — innerhalb einer unterzeichneten Baseline; Änderung nur über einen Change Request.',
  // sections
  'Requirements': 'Anforderungen',
  'Deliverables': 'Lieferobjekte',
  'Parties and engagement': 'Parteien und Auftrag',
  'Background and objectives': 'Ausgangslage und Ziele',
  'Scope of work': 'Leistungsumfang',
  'Assumptions': 'Annahmen',
  'Constraints': 'Rahmenbedingungen',
  'Timeline and milestones': 'Zeitplan und Meilensteine',
  'Fees and payment schedule': 'Honorar und Zahlungsplan',
  'Acceptance procedure': 'Abnahmeverfahren',
  'Annex A — Acceptance criteria': 'Anhang A — Abnahmekriterien',
  'Signatures': 'Unterschriften',
  // table heads / labels
  'Ref': 'Ref',
  'Requirement': 'Anforderung',
  'Priority': 'Priorität',
  'Type': 'Typ',
  'Delivered by': 'Geliefert durch',
  'Deliverable and acceptance criteria': 'Lieferobjekt und Abnahmekriterien',
  'Milestone': 'Meilenstein',
  'Done when:': 'Erledigt, wenn:',
  'Satisfies': 'Erfüllt',
  'Criterion': 'Kriterium',
  'Measured by': 'Gemessen durch',
  'Client': 'Kunde',
  'Consultant': 'Berater',
  'Engagement': 'Auftrag',
  'Client contact': 'Ansprechperson Kunde',
  'Commercial model': 'Kommerzielles Modell',
  'Period': 'Zeitraum',
  'Governing law': 'Anwendbares Recht',
  'Fee basis': 'Honorarbasis',
  'Total fees': 'Gesamthonorar',
  'Invoicing': 'Rechnungsstellung',
  'Payment terms': 'Zahlungsbedingungen',
  'Expenses': 'Spesen',
  'Status': 'Status',
  'For the Client': 'Für den Kunden',
  'For the Consultant': 'Für den Berater',
  'name, title, date': 'Name, Funktion, Datum',
  'The Consultant': 'Der Berater',
  'To be nominated': 'Noch zu benennen',
  'to be agreed': 'noch zu vereinbaren',
  'in-scope requirements': 'Anforderungen im Umfang',
  'deliverables': 'Lieferobjekte',
  'acceptance criteria': 'Abnahmekriterien',
  // type / priority values
  // empty states
  'None recorded in the register.': 'Nichts im Register erfasst.',
  'No in-scope requirements are recorded in the register.': 'Im Register sind keine Anforderungen im Umfang erfasst.',
  'No deliverables are recorded for this engagement.': 'Für diesen Auftrag sind keine Lieferobjekte erfasst.',
  'No milestones are recorded for this engagement.': 'Für diesen Auftrag sind keine Meilensteine erfasst.',
  'No background has been recorded for this engagement.': 'Für diesen Auftrag ist keine Ausgangslage erfasst.',
  'No acceptance criteria recorded.': 'Keine Abnahmekriterien erfasst.',
  'No acceptance criteria are recorded. Acceptance will be assessed against the definitions of done above.': 'Keine Abnahmekriterien erfasst. Die Abnahme erfolgt gegen die obigen Erledigungsdefinitionen.',
  // SOW copy
  'The Consultant shall deliver the requirements set out below. These requirements, and only these requirements, form the agreed baseline for this Statement of Work. {must} of {total} are classified as must.': 'Der Berater liefert die unten aufgeführten Anforderungen. Diese Anforderungen — und nur diese — bilden die vereinbarte Baseline dieses Statement of Work. {must} von {total} sind als «must» klassifiziert.',
  'The following are expressly not included in this Statement of Work. They are listed because they were discussed: their absence here is deliberate, not an oversight. Bringing any of them into scope requires an approved Change Request.': 'Folgendes ist ausdrücklich nicht Bestandteil dieses Statement of Work. Es wird aufgeführt, weil es besprochen wurde: Sein Fehlen ist beabsichtigt, kein Versehen. Eine Aufnahme in den Umfang erfordert einen genehmigten Change Request.',
  'This Statement of Work is priced and scheduled on the following assumptions. If an assumption proves false, the affected work is handled under Change control.': 'Dieses Statement of Work ist auf Basis der folgenden Annahmen kalkuliert und terminiert. Erweist sich eine Annahme als falsch, wird die betroffene Arbeit über die Änderungssteuerung behandelt.',
  'The following constraints bind the solution and were treated as fixed when scoping this work.': 'Die folgenden Rahmenbedingungen binden die Lösung und wurden bei der Festlegung des Umfangs als gegeben behandelt.',
  'Each deliverable is presented for acceptance against its definition of done and the acceptance criteria in Annex A. The Client reviews within {n} working days of issue; a deliverable not rejected in writing within that window is deemed accepted.': 'Jedes Lieferobjekt wird gegen seine Erledigungsdefinition und die Abnahmekriterien in Anhang A zur Abnahme vorgelegt. Der Kunde prüft innerhalb von {n} Arbeitstagen nach Übergabe; ein in dieser Frist nicht schriftlich abgelehntes Lieferobjekt gilt als abgenommen.',
});
